import { useOktaAuth } from '@okta/okta-react';
const useAuths = () => {
  const { oktaAuth, authState } = useOktaAuth();
  const login = () => oktaAuth.signInWithRedirect();
  const logout = () => oktaAuth.signOut();

  return { authState, login, logout };
};
export default useAuths;
